<template>
  <!-- eslint-disable-next-line no-irregular-whitespace -->
  <div class="serverTecSupport">
    <Header />
    <Content />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header.vue';
import Content from '@/components/content.vue';
import Footer from '@/components/footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Content,
    Footer,
  },
  data () {
    return {
      visible: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (
        document.body.scrollTop > 0 ||
        document.documentElement.scrollTop > 0
      ) {
        document.body.classList.add('has-top-banner');
      } else {
        document.body.classList.remove('has-top-banner');
      }
    },
  },
};
</script>

<style scoped></style>
